module.exports = __webpack_public_path__ + "1e4afc73963915677afdf2515dd02f0c.svg";